/*
|--------------------------------------------------------------------------
| Ready Function
|--------------------------------------------------------------------------
|
| import ready from 'Utils/global';
| ready(() => init());
|
*/

export default Document.prototype.ready = (fn) => {
  if (fn && typeof fn === 'function') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        return fn();
      }
    });
  }
};

/*
|--------------------------------------------------------------------------
| Global Variables
|--------------------------------------------------------------------------
*/

export const HTML = document.documentElement;
export const BODY = document.body;